import "./DataTableUI.css"

import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, LabelPosition, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { Toolbar, useTheme } from "@mui/material";
import { provinsionalInitialData, provinsionalheaderColumns } from "../globalVariablesconstants";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { isEqual } from "lodash";

let emptyProvinsionalStatus = {
  id: null,
  fromA: null,
  toA: null,
  rateV: null,
  constantKP: null,
};



interface IProvinsionalDataTable {
  provinsionalData: (data: any) => void;
  TableDataGetById: any
}
export const ProvinsionalDataTable: FC<IProvinsionalDataTable> = ({
  provinsionalData,
  TableDataGetById
}) => {
  const theme = useTheme()
  const [provinsional, setProvinsional] = useState<any>(provinsionalInitialData);
  // const [selectedProvinsional, setSelectedProvinsional] = useState<any>(null);
  const [empStatus, setEmpStatus] = useState(emptyProvinsionalStatus);

  // useEffect(() => {
  //   provinsionalData(provinsional);
  // }, [provinsional]);

  useEffect(() => {
    if (TableDataGetById) {
      setProvinsional(TableDataGetById);
    } else {
      setProvinsional(provinsionalInitialData)
    }
  }, [TableDataGetById]);

  // useEffect(() => {
  //   provinsionalData(provinsional);

  // }, [provinsional]);

  useEffect(() => {
    if (!isEqual(provinsional, TableDataGetById)) {
      provinsionalData([...provinsional]);
    }
  }, [provinsional]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < provinsional.length; i++) {
      if (provinsional[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = '';
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const openNew = () => {

    let _provinsional = [...provinsional];
    let _empStatus: any = { ...empStatus };

    if (empStatus.id) {
      const index = findIndexById(empStatus.id);

      _provinsional[index] = _empStatus;
    } else {
      _empStatus.id = createId();
      _provinsional.push(_empStatus);
    }



    setProvinsional(_provinsional);
    setEmpStatus(emptyProvinsionalStatus);
  };
  const resetData = () => {
    setProvinsional(provinsionalInitialData.map((item: any) => ({ id: item.id, item: null })));
  };

  // const confirmDeleteSelected = () => {
  //   let _provinsional = provinsional.filter((val:any) => !selectedProvinsional.includes(val));
  //   setProvinsional(_provinsional);
  //   setSelectedProvinsional(null);
  // };

  // const onMoveUpClickHandler = () => {
  //   let newData = [...provinsional];
  //   const selectedIndices = selectedProvinsional.map((item:any) => 
  //     newData.findIndex((dataItem) => dataItem.id === item.id)
  //   );

  //   selectedIndices.forEach((index:any) => {
  //     if (index > 0) {
  //       [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
  //     }
  //   });
  //   setProvinsional(newData);

  // };
  // const onMoveDownClickHandler = () => {
  //   let newData = [...provinsional];
  //   const selectedIndices = selectedProvinsional
  //     .map((item:any) => newData.findIndex((dataItem) => dataItem.id === item.id))
  //     .sort((a:any, b:any) => b - a); 

  //   selectedIndices.forEach((index:any) => {
  //     if (index < newData.length - 1) {
  //       [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
  //     } 
  //   });
  //   setProvinsional(newData);

  // };

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // setProvinsional((prev:any) => {
    //   const updatedData = [...prev];
    //   updatedData[rowIndex][event.field] = field;

    //   return updatedData;
    // });
    setProvinsional((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  // const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
  //   if (field.field === "date") {
  //     if (rowData.status !== "" && rowData.status !== undefined && rowData.status !== null) {
  //       if(rowData.date === null){
  //         return "p-component p-filled calender-error-input"; 
  //       } else if(rowData.date === ""){
  //         return "p-component p-filled calender-error-input"; 
  //       }
  //     }
  //   } else {
  //     return "p-component p-filled input-dropdown-fields";
  //   }
  // };

  const columnsBody = (rowData: any, row: any, x: any) => {
    // if(x.field === 'notes'){
    //   return (
    //     <InputText
    //         value={rowData[x.field]}
    //         onChange={(e: any) =>
    //           onCellValueChange(x, row.rowIndex, e.target.value)
    //         }
    //         placeholder="Write notes here"
    //         className={renderErrorClass(x, row.rowIndex, rowData)}
    //       />
    //     )
    // }
    return (
      <InputNumber
        // inputId={`yoo-field`}
        value={rowData[x.field]}
        // onValueChange={(e: any) =>
        //             onCellValueChange(x, row.rowIndex, e.target.value)
        //           }
        onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
        placeholder={"0.00"}
        minFractionDigits={2}
        maxFractionDigits={10}
        inputStyle={{
          textAlign: "right",
        }}
      // className={renderErrorClass(x, row.rowIndex, rowData)}
      />
    )
  }



  return (
    <>
      <div className="card">
        <Toolbar sx={{ justifyContent: "end", paddingRight: "0!important" }}>
          <>
            <EnhancedButtonPrimeReact
              label="Add"
              raised
              onClickHandler={openNew}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
            />
            <EnhancedButtonPrimeReact
              label="Clear Data"
              raised
              onClickHandler={resetData}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Warning}
            />
          </>
        </Toolbar>
        <DataTable
          value={provinsional}
          // selection={selectedProvinsional} 
          // onSelectionChange={(e) => setSelectedProvinsional(e.value)}
          dataKey="id"
          showGridlines
          className="DataTableUI"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          // selectionMode="checkbox"
          scrollHeight="516px"
        >
          {/* <Column
                      selectionMode="multiple"
                      // hidden={!showChecboxColumn}
                      frozen={true}
                      resizeable={false}
                      style={{ 
                        width: "36px",
                        textAlign: "center",
                        // zIndex:1,
                        borderRight:"1px solid #e5e7eb",
                        top:0
                       }}
                      field="selection"
                      columnKey="selection"
                      className="selectionHeader"
                      // headerStyle={{zIndex:'2!important'}}
                    /> */}
          {provinsionalheaderColumns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                headerTooltip={x.description}
                headerTooltipOptions={{ position: "top" }}
                // sortable={false}
                // resizeable={x.resizable}
                // dataType={x.type}
                align={x.align}
                alignHeader={x.headerAlign}
                // reorderable={x.disableReorder}
                // exportable={x.disableExport}
                frozen={x.frozenColumn}
                columnKey={x.field}
                style={{
                  width: x.minWidth,
                  fontSize: "0.875rem",
                }}
                footer={x.footer}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
